import styled from "styled-components";
import { isMobileOnly, isTablet } from "react-device-detect";

export const AboutContainer = styled.div`
  font-size: ${() => (isMobileOnly ? "20px" : isTablet ? "20px" : "24px")};
`;
export const About = styled.div`
margin-top: ${() => (isMobileOnly || isTablet ? "150px" : "150px")};
  color: #fff;
  position: absolute;
  margin-right: 4vw;
  top: ${() => (isMobileOnly ? "-4.5rem" : isTablet ? "-3rem" : "5vh")};
  left: ${() => (isMobileOnly ? "5vw" : isTablet ? "4.5vw" : "3vw")};
  width: ${() => (isMobileOnly ? "90vw" : isTablet ? "83vw" : "40em")};
`


export const Description = styled.p`
  margin: 0;
  line-height: 1.3;
`;

export const AboutLink = styled.div`
  margin-top: 25px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  height: 105%;
  left: 0;
  --swiper-navigation-size: 15px;
  &:hover {
    text-decoration: none;
    color: rgb(120, 120, 120);
  }
  @media screen and (max-width: 520px) {
    display: none;
  }
`;

export const Mail = styled.a`
  display:block;
   @media screen and (min-width: 575px) {
    display: none;
  }
`;

export const IG = styled.a`
  outline: none;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
`;

export const Phone = styled.a`
  outline: none;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  &:hover {
    text-decoration: none;
    color: rgb(120, 120, 120);
  }
`;

export const Pubs = styled.div`
color: #fff;
 font-size: ${() => (isMobileOnly ? "17px" : isTablet ? "18px" : "20px")};
 position: absolute;
  margin-right: 4vw;
  top: ${() => (isMobileOnly ? "61vh" : isTablet ? "61vh" : "72vh")};
  left: ${() => (isMobileOnly ? "5vw" : isTablet ? "4.5vw" : "3vw")};
  width: ${() => (isMobileOnly ? "80vw" : isTablet ? "83vw" : "37em")};
  
`

export const Exibition = styled.div`
color: #fff;
 font-size: ${() => (isMobileOnly ? "17px" : isTablet ? "18px" : "20px")};
 position: absolute;
  margin-right: 4vw;
  top: ${() => (isMobileOnly ? "46vh" : isTablet ? "46vh" : "52vh")};
  left: ${() => (isMobileOnly ? "5vw" : isTablet ? "4.5vw" : "3vw")};
  width: ${() => (isMobileOnly ? "80vw" : isTablet ? "83vw" : "37em")};
  
`